import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import { Spin } from "antd";
import { Toast } from "react-bootstrap";

type Permission = { id: number; name: string };

type Admin = {
  permissions: Array<number>;
  subcategory_name: string | null;
  subcategory_id: number;
  category: number | null;
};

type Category = {
  category_id: number;
  category_name: string;
};

interface ErrorMessages {
  subcategory_name?: string[];
}


const NonChaitanyaSummerCampEditSubCatgegory = () => {
  const routes = all_routes;
  const location = useLocation();
  const { id } = location.state || {};
  console.log(id);
  const navigate = useNavigate();
  const [chosenPermissions, setChosenPermissions] = useState<Permission[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [categoriesData1, setCategoriesData1] = useState<Category[]>([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState<Option | null>(
    null
  );
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
const [toastMessage, setToastMessage] = useState("");
useEffect(() => {
    if((showSolidDangerToast || showSolidSuccessToast) === true){
    setTimeout(() => setShowSolidDangerToast(false), 5000);
    setTimeout(() => setshowSolidSuccessToast(false), 5000);
    }
  },[toastMessage])
  const [selectedCategory, setSelectedCategory] = useState<Option | null>(null);

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const [newAdmin, setNewAdmin] = useState<Admin>({
    subcategory_name: null,
    subcategory_id: 0,
    permissions: [],
    category: null,
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchSubCategoryData = async (id: string) => {
    const response = await fetch(
      `${webApi}/outdoor_summercamp/odsubcategory/${id}`,
      options
    );
    return await response.json();
  };

  const fetchCategoryData = async () => {
    const response = await fetch(
      `${webApi}/outdoor_summercamp/odcategory_dropdown/`,
      options
    );
    return await response.json();
  };

  const fetchData = async () => {
    setIsLoading(true); // Start loading
    try {
      const [subCategoryData, categoriesData] = await Promise.all([
        fetchSubCategoryData(id),
        fetchCategoryData(),
      ]);
      setCategoriesData1(categoriesData);

      setNewAdmin({
        subcategory_name: subCategoryData.subcategory_name,
        subcategory_id: subCategoryData.subcategory_id,
        permissions: subCategoryData.permissions,
        category: subCategoryData.category,
      });

      const selectedCategory = categoriesData.find(
        (c: { category_id: any }) => c.category_id === subCategoryData.category
      );
      setSelectedCategory(
        selectedCategory
          ? {
              value: selectedCategory.category_id.toString(),
              label: selectedCategory.category_name,
            }
          : null
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const handlePermissionsChange = (selected: Permission[]) => {
    setNewAdmin({
      ...newAdmin,
      permissions: selected.map((permission) => permission.id),
    });
  };

  useEffect(() => {
    if (!checkPermission("change_odsubcategory", "odsubcategory")) {
      navigate(routes.adminDashboard);
    } else {
      fetchData();
    }
  }, [userPermissions]);

  const updateData = async () => {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newAdmin),
    };
    const url = `${webApi}/outdoor_summercamp/odsubcategory/${id}/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();
      setErrorMessage(errorData);
      setToastMessage(errorData.subcategory_name);
      if (toastMessage !== "") {
        setShowSolidDangerToast(true);
      }
      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading1(true);
    try {
      await updateData();
      navigate(routes.NonChaitanyaSubCategories);
    } catch (error) {
    } finally {
      setIsLoading1(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewAdmin({ ...newAdmin, [name]: value || null });
  };

  const handleCategoryChange = (selected: Option | null) => {
    const category = categoriesData1.find(
      (c) => c.category_id === parseInt(selected?.value || "")
    );

    setSelectedCategory(
      category
        ? {
            value: category.category_id.toString(),
            label: category.category_name,
          }
        : null
    );

    setNewAdmin({
      ...newAdmin,
      category: category?.category_id || null,
    });
  };

  useEffect(() => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);

  const categoryOptions = categoriesData1.map((c) => ({
    value: c.category_id.toString(),
    label: c.category_name,
  }));

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Non Chaitanya SummerCamp Edit Sub Category</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.NonChaitanyaSubCategories}>
                      Sub Categories
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Edit Sub Category</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Row */}
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              {/* Add Group */}
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      height: "100vh",
                      paddingTop: "20px",
                    }}
                  >
                    <Spin /> {/* Display loader while loading */}
                  </div>
                ) : (
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3 me-3" style={{ width: "35%" }}>
                        <label className="form-label">Category</label>
                        <CommonSelect
                          className="select"
                          options={categoryOptions}
                          onChange={handleCategoryChange}
                          value={selectedCategory}
                          isRequired={true}
                        />
                      </div>
                      <div className="form-group mb-3" style={{ width: "35%" }}>
                        <label className="form-label">Sub Category Name</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errorMessage.subcategory_name ? "is-invalid" : ""
                          }`}
                          name="subcategory_name"
                          placeholder="Group Name"
                          onChange={handleInputChange}
                          value={newAdmin.subcategory_name || ""}
                          required
                        />
                         {errorMessage.subcategory_name && (
                        <div className="invalid-feedback">
                          {errorMessage.subcategory_name[0]}
                        </div>
                      )}
                      </div>
                      <div className="modal-footer">
                        <Link
                          className="btn btn-primary"
                          type="submit"
                          to={routes.SummerCampSubCategories}
                          style={{
                            backgroundColor: "lightcoral",
                            color: "white",
                            marginRight: "5px",
                          }}
                        >
                          Cancel
                        </Link>
                        <button
                          className="btn btn-primary"
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading1 ? (
                            <i className="spinner-border spinner-border-sm"></i>
                          ) : (
                            <>Save</>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                )}
              </div>
              {/* /Add Group */}
            </div>
          </div>
          {/* /Row */}
          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          <Toast
            show={showSolidSuccessToast}
            onClose={handleSolidSuccessToastClose}
            id="solidSuccessToast"
            className="colored-toast bg-success text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </div>
      </div>
    </div>
  );
};

export default NonChaitanyaSummerCampEditSubCatgegory;
